module.exports = "/src/views/player/help/images/azart5.jpg";